import { HttpErrorResponse } from '@angular/common/http';

/**
 * « Le serveur ne sait pas qui je suis » — la reponse d'une LISTE sans parametre (`GET /calls/pending`,
 * `GET /chat/conversations`) qui echoue en 400.
 *
 * Ces routes ne recoivent que le jeton. Un 400 y veut dire que le compte du jeton n'existe pas, ou n'est plus actif,
 * dans la base : reessayer toutes les 5 secondes n'y changera rien avant une nouvelle connexion, et chaque
 * tentative laisse une erreur rouge dans la console. Le polling s'arrete donc, avec UNE ligne d'avertissement.
 *
 * Volontairement limite a ces deux listes : un 400 sur une route a parametre (messages d'une conversation, statut
 * d'un appel) peut venir d'un identifiant perime, et ne doit pas couper tout le polling. 401 est deja gere par
 * l'intercepteur (rafraichissement du jeton) ; 5xx et reseau coupe se resolvent d'eux-memes : on continue.
 */
export function identiteIntrouvable(erreur: unknown): boolean {
  return erreur instanceof HttpErrorResponse && erreur.status === 400;
}
